var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoCircleNew = function SvgInfoCircleNew(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 1.5C6.20003 1.5 1.49902 6.20101 1.49902 12C1.49902 17.799 6.20003 22.5 11.999 22.5C17.798 22.5 22.499 17.799 22.499 12C22.499 9.21523 21.3928 6.54451 19.4236 4.57538C17.4545 2.60625 14.7838 1.5 11.999 1.5ZM11.999 5.25C12.6203 5.25 13.124 5.75368 13.124 6.375C13.124 6.99632 12.6203 7.5 11.999 7.5C11.3777 7.5 10.874 6.99632 10.874 6.375C10.874 5.75368 11.3777 5.25 11.999 5.25ZM14.999 18.09H8.99902V16.41H11.159V11.34H9.74902V9.66H12.8465V16.41H14.999V18.09Z",
    fill: "#999999"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoCircleNew);
export default ForwardRef;